import { getAxiosInstance } from "../../../api";

export const addRemittanceNote = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.post(`/admin/remittance/save-note`, body);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getRemittanceNoteHistory = async (remittanceId) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(`/admin/remittance/view-note`, {
      params: { remittance_id: remittanceId },
    });
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const changeRemittancePaymentStatus = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.put(
      `/admin/remittance/change-payment-status`,
      body
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const exportRemittance = async (params) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.get(`/admin/remittance/export`, {
      params,
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const changeRemittanceStatus = async (body) => {
  const api = await getAxiosInstance();
  try {
    const response = await api.put(`/admin/remittance/change-status`, body);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};
